import { nextTick } from 'vue';

export default defineNuxtRouteMiddleware((to) => {
  // 클라이언트 사이드에서만 실행
  if (process.client) {
    // nextTick을 사용해 Vue가 준비된 후에 실행
    nextTick(() => {
      const menuStore = useMenuStore()
      const { $logoText } = useNuxtApp()

      if (!$logoText) return

      const currentPath = to.path
      let bestMatch = null
      let maxMatchLength = 0

      // 모든 메뉴 아이템을 수집하고 가장 긴 매칭을 찾기
      const allMenuItems = []

      for (const section of menuStore.sections) {
        // 메인 아이템들 수집
        if (section.items) {
          allMenuItems.push(...section.items)
        }

        // 서브메뉴 아이템들 수집
        if (section.submenus) {
          for (const submenu of section.submenus) {
            if (submenu.items) {
              allMenuItems.push(...submenu.items)
            }
          }
        }
      }

      // 가장 긴 경로 매칭 찾기
      for (const item of allMenuItems) {
        if (item.path && item.path !== '/' && currentPath.startsWith(item.path)) {
          if (item.path.length > maxMatchLength) {
            maxMatchLength = item.path.length
            bestMatch = item
          }
        }
      }

      // 가장 잘 매칭되는 메뉴 이름 설정
      if (bestMatch) {
        $logoText.value = bestMatch.name
      }
    })
  }
})
